
import {onMounted, ref, watchEffect} from 'vue';
import {GetHotspotBenefits} from 'Apis/apis';
import {throttle} from 'throttle-debounce';


export default {
	name: 'HotspotPopup',
	props: {
		id: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		let title = ref('');
		let description = ref('');
		let hotspotcontent = ref(null);
		let leftOffset = ref(null);
		let rightOffset = ref(null);
		let positionClass = ref('');
		let threshhold = ref(0);

		async function getBenefits(id) {
			const benefit = await GetHotspotBenefits(id);
			if (benefit.value.length) {
				title.value = benefit.value[0].DisplayTitle;
				description.value = benefit.value[0].Description;
			}
		}

		let getPositionClass = () => {
			threshhold.value = 200;

			if(leftOffset.value > threshhold.value && (window.innerWidth - (leftOffset.value + (hotspotcontent.value.offsetWidth / 2)) > threshhold.value)) {
				positionClass.value = "hotspot__content--centered";
			} else if(leftOffset.value < threshhold.value) {
				positionClass.value = "hotspot__content--left";
			} else {
				positionClass.value = "hotspot__content--right";
			}
		};

		onMounted(() => {
			getBenefits(props.id);

			watchEffect(() => {
				adjustPopupPosition();
				getPositionClass();
			});

			window.addEventListener('resize', throttle(1000, false, () => {
				adjustPopupPosition();
				getPositionClass();
			}));
		});

		let adjustPopupPosition = () => {
			let leftPosition = hotspotcontent.value ? hotspotcontent.value.getBoundingClientRect().left : null;
			let viewportLeftPosition = window.pageXOffset || document.documentElement.scrollLeft;
			leftOffset.value = leftPosition - viewportLeftPosition;
			rightOffset.value = window.innerWidth - (leftPosition + (hotspotcontent.value ? hotspotcontent.value.offsetWidth : 0));
		}

		return {
			title,
			description,
			leftOffset,
			rightOffset,
			hotspotcontent,
			positionClass
		};
	},
};
